// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import PerformanceWhatsappFormModal from './FormModal';
import PerformanceWhatsappForm from './Form';

export default class PerformanceWhatsappFormApp extends Component {
  render() {
    return (
      <PerformanceWhatsappFormModal
        openModalTriggerSelector={this.props.openModalTriggerSelector}
      >
        <PerformanceWhatsappForm
          channel={this.props.channel}
          product={this.props.product}
          cloneId={this.props.cloneId}
          category={this.props.category}
          brand={this.props.brand}
          link={this.props.link}
          formId={this.props.formId}
          buttonLabel={this.props.buttonLabel}
          showCpf={this.props.showCpf}
          showUnits={this.props.showUnits}
          showContactOptions={this.props.showContactOptions}
          showEmail={this.props.showEmail}
          showDataPermissions={this.props.showDataPermissions}
          dataPermissionsCustomText={this.props.dataPermissionsCustomText}
          linkPrivacyPolicy={this.props.linkPrivacyPolicy}
          units={this.props.units}
          unit={this.props.unit}
          hasModel={this.props.hasModel}
          emailPlaceholder={this.props.emailPlaceholder}
          phonePlaceholder={this.props.phonePlaceholder}
          showModelsSelect={this.props.showModelsSelect}
          // eslint-disable-next-line react/prop-types
          customFields={this.props.customFields}
        />
      </PerformanceWhatsappFormModal>
    );
  }
}

PerformanceWhatsappFormApp.defaultProps = {
  openModalTriggerSelector: null,
  buttonLabel: 'Converse agora!',
  showContactOptions: true,
  unit: '',
  hasModel: false,
  showModelsSelect: false,
  // eslint-disable-next-line react/default-props-match-prop-types
  customFields: [],
};

PerformanceWhatsappFormApp.propTypes = {
  openModalTriggerSelector: PropTypes.string,
  formId: PropTypes.string,
  buttonLabel: PropTypes.string,
  product: PropTypes.string,
  cloneId: PropTypes.string,
  channel: PropTypes.string,
  category: PropTypes.string,
  brand: PropTypes.string,
  link: PropTypes.string,
  showCpf: PropTypes.bool,
  showUnits: PropTypes.bool,
  showContactOptions: PropTypes.bool,
  showEmail: PropTypes.bool,
  linkPrivacyPolicy: PropTypes.string,
  showDataPermissions: PropTypes.bool,
  dataPermissionsCustomText: PropTypes.string,
  units: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  unit: PropTypes.string,
  hasModel: PropTypes.bool,
  emailPlaceholder: PropTypes.string,
  phonePlaceholder: PropTypes.string,
  showModelsSelect: PropTypes.bool,
};
